<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Cuadro de Quinielas
                </h2>

                <div class="row">
                    <div class="col-sm">
                        <a href="#" data-toggle="modal" data-target="#crear"
                            class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                            style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 200px;">
                            <i class="icofont-soccer"></i> Crear una Quiniela </a>
                    </div>
                    <div class="col-sm">
                        <a routerLink="/eliminar"
                            class="btn-get-started-danger animate__animated animate__faster animate__fadeInDown"
                            style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 200px;border: 2px solid #dc3545;">
                            <i class="icofont-trash"></i> Eliminar una Quiniela</a>
                    </div>
                </div>




                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container">

                        <app-loader *ngIf="isLoading"></app-loader>

                        <div class="row">

                            <div class="col-lg-4 col-md-6 mb-5 mt-md-0 mt-lg-0" *ngFor="let quiniela of quinielas">
                                <div class="icon-box" data-aos="zoom-in-left">
                                    <div class="icon"><i class="icofont-football-alt" style="color: #33364a;"></i></div>
                                    <h4 class="title" style="margin-left: 0px;"><a href="">{{ quiniela.titulo }}</a>
                                    </h4>
                                    <p class="description" style="color: black;text-align: left;">
                                        <b>Precio: </b> {{ quiniela.precio }} {{quiniela.moneda}} <br />
                                        <b>Teléfono: </b> <br />{{ quiniela.telefono }}<br />
                                        <b>Email: </b> <br />{{ quiniela.email }}
                                    </p>
                                    <a href="#" data-toggle="modal" [attr.data-target]="'#editar-' + quiniela.$key"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;color: #fff;background-color: #6c757d;border-color: #6c757d;">
                                        <i class="icofont-edit"></i> Editar
                                    </a>
                                    <a routerLink="/quiniela/{{ quiniela.$key }}"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;background-color:#ef6603;">
                                        <i class="icofont-swoosh-right"></i> Entrar
                                    </a>
                                </div>
                            </div>
                            <!--
                            <div class="col-lg-4 col-md-6 mb-5 mt-md-0 mt-lg-0">
                                <div class="icon-box" data-aos="zoom-in-left">
                                    <div class="icon"><i class="icofont-football-alt" style="color: #33364a;"></i></div>
                                    <h4 class="title" style="margin-left: 0px;"><a href="">Fundación Luz</a></h4>
                                    <p class="description" style="color: black;text-align: left;">
                                        <b>Evento: </b> Copa America <br />
                                        <b>Precio: </b> $ 5 <br />
                                        <b>Teléfono: </b> <br />+58 412 907 6968<br />
                                        <b>Email: </b> <br />manuel_marg@hotmail.com
                                    </p>
                                    <a href="#" data-toggle="modal" data-target="#crear"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;color: #fff;background-color: #6c757d;border-color: #6c757d;">
                                        <i class="icofont-edit"></i>
                                        Editar
                                    </a>
                                    <a href="#" data-toggle="modal" data-target="#crear"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;background-color:#ef6603;">
                                        <i class="icofont-swoosh-right"></i>
                                        Entrar
                                    </a>
                                </div>
                            </div>
                            -->

                        </div>

                    </div>
                </section>
                <!-- End Services Section -->


            </div>
        </div>
    </div>

    <!-- Modal para Agregar una nueva Quiniela-->
    <div class="modal fade" id="crear" tabindex="-1" role="dialog" aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">Crear una nueva Quiniela</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Telefono">
                                <input required type="text" name="input" id="Telefono" />
                                <label>Ingrese su número de Teléfono</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Email">
                                <input required type="text" name="input" id="Email"/>
                                <label>Ingrese su Correo Electrónico</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Titulo">
                                <input required type="text" name="input" id="Titulo"/>
                                <label>Ingrese el Titulo o Nombre de la Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" style="height: 100px;" id="div-Descripcion">
                                <textarea required type="text" name="input" id="Descripcion" style="padding-top: 10px;" class=""></textarea>
                                <label>Ingrese una breve descripción para la Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-URL">
                                <input required type="text" name="input" id="URL"/>
                                <label>Ingrese una palabra clave para formar el Link de su Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Precio">
                                <input required type="number" name="input" id="Precio" />
                                <label>Ingrese un precio para la Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Moneda">
                                <input required type="text" name="input" id="Moneda"/>
                                <label>Ingrese tipo de moneda o el simbolo la Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" id="div-Porcentaje">
                                <input required type="number" name="input" id="Porcentaje"/>
                                <label>Ingrese el porcentaje a repartir de pote de la Quiniela</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <div class="input-group mb-2">
                            <div class="form-control-google" style="height: 100px;" id="div-DatosPago">
                                <textarea required type="text" name="input" id="DatosPago" style="padding-top: 10px;"></textarea>
                                <label>Ingrese sus datos de pago (Tranferencia, Zelle, PagoMovil)</label>
                                <div class="border-around"></div>
                            </div>
                        </div>
                        <!-- FORMULARIO ANTERIOR QUE NO TENIA BUENA APARIENCIA
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Teléfono</div>
                            </div>
                            <input type="text" id="Telefono" class="form-control" autocomplete="off"
                                placeholder="Ingrese el Nro. teléfono de contacto">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;&nbsp;Email&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Email" class="form-control" autocomplete="off"
                                placeholder="Ingrese el correo electronico de contacto">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Titulo&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Titulo" class="form-control" autocomplete="off"
                                placeholder="Ejemplo: Edif-Mary2">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Descripción</div>
                            </div>
                            <textarea class="form-control" id="Descripcion" rows="3"
                                placeholder="Finalidad de la quiniela, ejemplo:Pro-fondos para comprar guayas del ascensor par y repararlo"></textarea>
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">http://TuQuinielaYa.web.app/</div>
                            </div>
                            <input type="text" id="URL" class="form-control" autocomplete="off"
                                placeholder="Ejemplo: mary2">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Precio&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Precio" class="form-control" autocomplete="off"
                                placeholder="Ingrese el Precio de cada Quiniela">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Moneda&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Moneda" class="form-control" autocomplete="off"
                                placeholder="Nombre o simbolo de la moneda Ej: ($,Bs,Pesos)">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Porcentaje a repartir&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Porcentaje" class="form-control" autocomplete="off" min="0"
                                max="100" placeholder="Ejemplo: 45 ">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Datos de Pago</div>
                            </div>
                            <textarea class="form-control" id="DatosPago" rows="3"
                                placeholder="Ingrese la información que le aparecera al usuario al terminar de llenar su Quiniela"></textarea>
                        </div>
                        -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseButton" class="btn btn-secondary"
                            data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="onSubmit()" class="btn btn-primary"
                            style="background: #ef6603;color: #fff;border-color: #ef6603;">Crear</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Modal para Editar una Quiniela-->
    <div *ngFor="let quiniela of quinielas" class="modal fade" id="editar-{{quiniela.$key}}" tabindex="-1" role="dialog"
        aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">Editar quiniela</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Teléfono</div>
                            </div>
                            <input type="text" id="Telefono-{{quiniela.$key}}" class="form-control"
                                value="{{quiniela.telefono}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;&nbsp;Email&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Email-{{quiniela.$key}}" class="form-control"
                                value="{{quiniela.email}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Titulo&nbsp;&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Titulo-{{quiniela.$key}}" class="form-control"
                                value="{{quiniela.titulo}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Descripción</div>
                            </div>
                            <textarea class="form-control" id="Descripcion-{{quiniela.$key}}" rows="3"
                                value="{{quiniela.descripcion}}"></textarea>
                        </div>
                        <div class="input-group mb-2">
                            <input type="text" id="URL-{{quiniela.$key}}" class="form-control text-center" disabled
                                value="tuquinielaya.web.app/{{quiniela.url}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Precio&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Precio-{{quiniela.$key}}" class="form-control"
                                value="{{quiniela.precio}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Moneda&nbsp;&nbsp;</div>
                            </div>
                            <input type="text" id="Moneda-{{quiniela.$key}}" class="form-control"
                                value="{{quiniela.moneda}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">&nbsp;&nbsp;Porcentaje a repartir&nbsp;&nbsp;</div>
                            </div>
                            <input type="number" id="Porcentaje-{{quiniela.$key}}" class="form-control"
                                autocomplete="off" min="0" max="100" value="{{quiniela.porcentaje}}">
                        </div>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">Datos de Pago</div>
                            </div>
                            <textarea class="form-control" id="DatosPago-{{quiniela.$key}}" rows="3"
                                value="{{quiniela.datos_de_pago}}"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseButton-{{quiniela.$key}}" class="btn btn-secondary"
                            data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="editar(quiniela)" class="btn btn-primary"
                            style="background: #ef6603;color: #fff;border-color: #ef6603;">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>


    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->